import { useCallback } from "react";
import { faUpload } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Menu, useMantineTheme } from "@mantine/core";
import { useAuth } from "stores/useAuth";
import { useGenericModals } from "hooks/useGenericModals";
import { useTranslation } from "react-i18next";

export const ImportGPXMenuItem = () => {
  const { t } = useTranslation();
  const theme = useMantineTheme();
  const { user } = useAuth();
  const { openInfoModal, openImportGPXmodal } = useGenericModals();

  const handleClick = useCallback(() => {
    if (!user) {
      openInfoModal(
        "Please sign in",
        "Importing GPX file is possible after sign-in."
      );
      return;
    }
    openImportGPXmodal();
  }, [openImportGPXmodal, openInfoModal, user]);

  return (
    <Menu.Item
      onClick={handleClick}
      leftSection={
        <FontAwesomeIcon icon={faUpload} color={theme.colors.gray[6]} />
      }
    >
      {t("dropdown_menu.import_gpx_label")}
    </Menu.Item>
  );
};
